module.exports = __webpack_public_path__ + "img/18_35.2e29f1ae.png";